
/* global initExtensions */
/*========================================================================
* $Id: extensions.js 97320 2017-04-07 11:14:01Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

// This file contains the parts for the registration and management
// of extensions.
Mindbreeze.define('extensions',[], function () {
  var definitions = {};
  var extensions = {}
  var exports = extensions;
  var api = exports;

  // Returns the schema for the type identifier.
  api.getType = function (identifier) {
    return Mindbreeze.types && Mindbreeze.types[identifier];
  },

  // Defines an object that can be looked up using the
  // identifier.
  //
  // **identifier** for the object (String)
  // **obj** the object to bind (Object)
  // **test** structural test that ensures the 
  //   availability of the bound object (Function, optional)
  api.define = function (identifier, obj, test) {
    if (typeof test === 'function') {
      try {
        test();
      } catch (e) {
        // TODO: handle error
        return;
      }
    }
    definitions[identifier] = obj;
    return identifier;
  };

  // Returns the object registered for **identifier** or undefined.
  api.lookup = function (identifier) {
    return definitions[identifier];
  };

  // Invokes a **method** of **service** using the given
  // **identifier** for the lookup of the implementation.
  // This method can be called by an extension provider to
  // call the implementation. The correct request is
  // determined by the context.
  api.invokeInContext = function (serviceName, methodName, identifier) {
  };

  // Helper for implementing the context-specific calls.
  exports.invokeInContextHelper = function (serviceName, methodName, identifier, callback) {
    var service = api.lookup(identifier),
        method,
        response;

    if (service) {
      method = service[methodName];
      if (method) {
        response = method.apply(service, Array.prototype.slice.apply(arguments, [4]));
        if (typeof callback === 'function') {
          if (response && typeof response.then === 'function') { // deferred-interface
            response.then(callback);
          } else {
            callback(response);
          }
        }
      }
    }
  };

  // Extends the Mindbreeze Client with the specified
  // **extension** for the given **extensionPoint**.
  api.extend = function (extensionPoint, extension) {
    if (!extension) return;
    if (extension.depends && !api.lookup(extension.depends)) {
      // TODO: log warning
      return;
    }

    exports.extensions._addExtension(extensionPoint, extension);
  }
  // The ExtensionRegistry is the internal interface for
  // managing installed extensions. Available via **Mindbreeze.extensions**.
  var ExtensionRegistry = function () {
    this._reset();
  };

  // Returns the extensions registered for the given extensionPoint.
  ExtensionRegistry.prototype.getExtensionsForExtensionPoint = function (extensionPoint) {
    return this.extensions[extensionPoint];
  };

  // Adds a extension to the registry.
  ExtensionRegistry.prototype._addExtension = function (extensionPoint, extension) {
    var extensionsForExtensionPoint = this.extensions[extensionPoint] || [];
    extensionsForExtensionPoint.push(extension);
    this.extensions[extensionPoint] = extensionsForExtensionPoint;
  };

  // Removes all registered extensions from the registry.
  ExtensionRegistry.prototype._reset = function (extension) {
    this.extensions = {};
  };

  exports.extensions = new ExtensionRegistry();

  if (typeof initExtensions === 'function') {
    initExtensions(Mindbreeze);
  }

  exports.require = Mindbreeze.require;

  return extensions;
});
